import { render } from "./PrimeiroPasso.vue?vue&type=template&id=e27d205e&ts=true"
import script from "./PrimeiroPasso.vue?vue&type=script&lang=ts"
export * from "./PrimeiroPasso.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/autoatendimento.totalvia.com.br/TotemAtendimento/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__